// extracted by mini-css-extract-plugin
module.exports = {"c1c9tkkl":"c1c9tkkl","tdxqwis":"tdxqwis","twy9zp4":"twy9zp4","i14lvkng":"i14lvkng"};